import React, { forwardRef, useContext } from 'react';
import { MeControlBase, CustomMenuBase } from '@bingads-webui-react/me-control';
import { makeStyles, mergeClasses } from '@fluentui/react-components';
import Uri from 'urijs';
import { LayoutSize } from '@bingads-webui-fluent-component/layout-size';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { MenuContext } from '@bingads-webui-fluent-component/global-menu-container';
import { ClientCenterCustomerService } from '@bingads-webui/clientcenter-customer-service';
import { LinkWithFallBack } from '@bingads-webui-react/fallback-feature';
import { CustomerSelector } from '@bingads-webui-react/customer-selector';

import type { MeControlItemProps } from './types';

const urlUpdater = ({ url, cid, uid }) => new Uri(url).query('').setQuery('cid', cid).setQuery('uid', uid)
  .toString();

const fallbackLinkFlags = {
  viewAllCustomers: false,
  customerManagement: false,
  supportDashboard: false,
  aggregatorWelcome: false,
};

const useStyles = makeStyles({
  container: { height: '100%' },
});

export const MeControlItem = forwardRef<HTMLDivElement, MeControlItemProps>(({
  supportUrl,
  hide,
  currentUser,
  perfMarker,
  settingsContext,
}, ref) => {
  const { layoutSize } = useContext(MenuContext);
  const classes = useStyles();
  const i18n = useContext(I18nContext);
  const showName = layoutSize === LayoutSize.XXL || layoutSize === LayoutSize.XL;
  const ccBaseUrl = settingsContext.Urls.ClientCenterBaseUrl;
  const customerService = new ClientCenterCustomerService({ ccBaseUrl });
  const isMultiUser = !!(currentUser.PersonId && currentUser.PersonId > 0);

  return (
    <div
      className={mergeClasses(classes.container, 'me-control')}
      ref={ref}
    >
      <MeControlBase
        user={currentUser}
        i18n={i18n}
        ccBaseUrl={settingsContext.Urls.RootUIUrl}
        customerService={customerService}
        url={window.location.href}
        isMultiUser={isMultiUser}
        isFullBreadcrumbMode={showName}
        customerUrlUpdater={urlUpdater}
        supportUrl={supportUrl}
        fallbackLinkFlags={fallbackLinkFlags}
        renderLink={LinkWithFallBack}
        hideCustomerSelector={hide.customerSelector}
        hideCustomerManagement={hide.customerManagement}
        perfMarker={perfMarker}
        CustomerSelector={CustomerSelector}
        CustomMenu={CustomMenuBase}
        forNewGlobalMenu
      />
    </div>
  );
});
